<script setup lang="ts">
useHead({
  title: 'Issues'
})
</script>
<template>
    <div class='section'>

            If you experience an issue please send an email to <a href="mailto:issues@milmed.ai">issues@milmed.ai</a>

    </div>
</template>